import script from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\BtnWhatsapp\\WhatsappIcon.vue?type=script"
export * from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\BtnWhatsapp\\WhatsappIcon.vue?type=script"
import { render } from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\BtnWhatsapp\\WhatsappIcon.vue?type=template"

script.render = render
export default script